import { QuestionTypeEnum } from '@/models/Question';
import { useTranslation } from 'react-i18next';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import { useTrueOrFalseCorrection } from './useTrueOrFalseCorrection';
import { twMerge } from 'tailwind-merge';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';

const answerClassName = {
  correct: 'border-success text-success bg-success/10',
  incorrect: 'border-error text-error bg-error/10',
  missed: 'border-base-content text-base-content bg-base-content/10',
};
export function TrueOrFalseCorrectionView(
  props: QuestionViewPropsFor<QuestionTypeEnum.TRUE_OR_FALSE>,
) {
  const { answer, answerStatus } = useTrueOrFalseCorrection(props);
  const { t } = useTranslation('translation', {
    keyPrefix: 'questionView.trueOrFalse',
  });
  const { t: studentAnswer } = useTranslation('translation', {
    keyPrefix: 'questionView',
  });

  return (
    <div className="flex w-full flex-col gap-2">
      <div
        className={twMerge(
          'border rounded-lg px-4 py-4 font-semibold grid grid-cols-2',
          answerClassName[answerStatus],
        )}
      >
        <div className={answerStatus === 'incorrect' ? 'line-through' : ''}>
          {t(answer)}
        </div>
        <ConditionalRenderer condition={props.showStudentAnswerMessage ?? true}>
          <div className="flex justify-end">
            {studentAnswer('studentAnswer')}
          </div>
        </ConditionalRenderer>
      </div>
    </div>
  );
}
